module.exports = __webpack_public_path__ + "static/media/growbag_shop1.ca18fb0a.webp";